var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SortableTable',{attrs:{"rows":_vm.allAlerts,"headers":_vm.eventHeaders,"search":false,"table-actions":false,"row-actions":false,"paging":true,"rows-per-page":10,"default-sort-by":"name","key-field":"id"}})}
var staticRenderFns = []

export { render, staticRenderFns }